
















import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import PHeader from "./header.vue";

@Component({
  components: { PHeader },
})
export default class PView extends Vue {
  // vuex
  @Getter("user/userInfo") public userInfo: any;
  @Getter("user/isLogin") public isLogin: any;
  @Action("user/getUserInfo") public getUserInfo: any;

  // created
  private async created() {
    // if (this.isLogin() && !this.userInfo.username) {
    //   try {
    //     await this.getUserInfo();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
  }
}
